// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3PBKN","inputWrap":"styles_inputWrap__egFrs","input":"styles_input__7jfa8"};